import get from 'lodash/get'
import isFinite from 'lodash/isFinite'
import {createSelector} from 'reselect'

import {status} from './helpers'

// Get

export const qualification = (state) => get(state, 'groomRentsFree.data')
export const isQualified = (state) => get(qualification(state), 'is_qualified')
export const disqualificationReasons = (state) =>
  get(qualification(state), 'disqualification_reasons')
export const context = (state) => get(qualification(state), 'context')
export const discount = (state) => get(context(state), 'discount')
export const qualifiedLookCount = (state) => get(context(state), 'qualified_user_event_look_count')
export const requirements = (state) => get(context(state), 'requirements')
export const minimumCount = (state) => get(requirements(state), 'MIN_NUM_PARTICIPANT_LOOKS')
export const minimumValue = (state) => get(requirements(state), 'MIN_ITEM_VALUE')

// Status

export const {isFailure, isSuccess} = status('groomRentsFree')

// Computed

// The number of looks the customer needs to add in order to qualify
export const remainingCount = createSelector(
  minimumCount,
  qualifiedLookCount,
  (minimum, qualified) =>
    isFinite(minimum) && isFinite(qualified) ? minimum - qualified : undefined,
)

export const promoCode = createSelector(context, (grfContext) =>
  get(grfContext, 'promo_code', '').toLowerCase(),
)
